import './Fulfillment.css';
import React, { useState } from 'react';
import { Container } from '../../components/Container/Container';
import { Card } from '../../components/Card/Card';
import { Form } from '../../components/Form/Form';
import { TextField } from '../../components/Form/TextField/TextField';
import { Button } from '../../components/Button/Button';
import { getDelivery } from '../../model/delivery';
import { handleError } from '../../model/notification';
import { history } from '../../model/history';
import { fulfillmentDetailsPath } from '../../routes';
import { t } from '../../locales/translate';
import { SimpleCheckbox } from '../../components/Form/Checkbox/Checkbox';
import { useData } from '../../model/data';
import { writeDB } from '../../model/store';
import { Stack } from '../../components/Stack/Stack';

export default function Fulfillment(): JSX.Element {
  return (
    <Container className="fulfillment">
      <Card title={t.actions.scan(t.model.delivery._name)}>
        <ScanForm />
        <SettingsForm />
      </Card>
    </Container>
  );
}

function ScanForm(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState({ reference: '' });

  async function handleOnSubmit(m: { reference: string }): Promise<void> {
    setLoading(true);
    try {
      const delivery = await getDelivery({ deliveryId: m.reference.trim() });
      if (delivery) {
        history.push(fulfillmentDetailsPath(delivery));
      }
    } catch (error) {
      handleError(error);
    }
    setLoading(false);
  }

  return (
    <Form model={model} onInput={(m) => setModel(m)} onSubmit={handleOnSubmit} className="fulfillment-form">
      <TextField autoFocus name="reference" label={t.model.delivery.scanDeliveryOrReference} required />
      <Button isSubmit loading={loading} title={t.actions.continue} type="primary" disabled={!model.reference} />
    </Form>
  );
}

function SettingsForm(): JSX.Element {
  const [printTickets, printLabel, useNewCSVDownload] = useData((db) => [
    db.get('printTickets'),
    db.get('printLabel'),
    db.get('useNewCSVDownload'),
  ]);

  return (
    <Stack className="fulfillment__settings">
      <SimpleCheckbox
        value={printLabel}
        onChange={() => writeDB.set('printLabel', !printLabel)}
        label={t.page.fulfillmentDetails.printDHLLabel}
      />
      <SimpleCheckbox
        value={printTickets}
        onChange={() => writeDB.set('printTickets', !printTickets)}
        label={t.page.fulfillmentDetails.printTickets}
      />
      <SimpleCheckbox
        value={useNewCSVDownload}
        onChange={() => writeDB.set('useNewCSVDownload', !useNewCSVDownload)}
        label="Use new csv download"
      />
    </Stack>
  );
}
